import React from "react";
import { Col, Row } from "reactstrap";

export const Section = ({ id }) => {
  return (
    <React.Fragment>
      <Row className="mb-3 pb-1">
        <Col xs={12}>
          <div className="d-flex align-items-lg-center flex-lg-row flex-column">
            <div className="flex-grow-1">
              <h4 className="fs-16 mb-1">
                {id ? "Editar Categoria" : "Nova Categoria"}
              </h4>
              <p className="text-muted mb-0">
                {`Preencha os campos para ${
                  id ? "editar" : "adicionar"
                } uma categoria.`}
              </p>
            </div>
          </div>
        </Col>
      </Row>
    </React.Fragment>
  );
};
